import * as request from "@/utils/request";
import { DefaultConfigs } from "@/common/js/constant";
import { transactionListParams, billTypes, transactionList } from "./types";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;

// 查询账单流水
export function getList(params: transactionListParams) {
  return request.post<transactionList>(`${baseUrl}/sofipo/v0/bill/list`, params);
}
// 获取标签列表
export function getOptions() {
  return request.get<billTypes>(`${baseUrl}/sofipo/v0/bill/options`, {});
}
